export default theme => ({
  root: {
    border: `1px solid ${theme.colors.grey[100]}`,
    background: theme.colors.actionMinor[50],
    '& button': {
      background: 'white !important'
    }
  },
  conditionString: {
    color: theme.colors.primary.black,
    wordBreak: 'break-word'
  },
  header: {
    padding: 10,
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  container: {},
  body: {
    padding: '10px'
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    minHeight: 40,
    padding: '5px 10px',
    borderTop: `1px solid ${theme.colors.grey[100]}`,
    '& div': {
      display: 'flex',
      alignItems: 'center',
      '& span:first-child': {
        marginRight: 5
      }
    }
  },
  expanded: {
    '& $container': {
      height: 'auto',
      overflow: 'visible',
      opacity: 1
    }
  },
  collapsed: {
    '& $container': {
      height: 0,
      overflow: 'hidden',
      opacity: 0
    },
    '& $footer': {
      cursor: 'pointer',
      borderTop: 'none'
    }
  },
  addConditionRight: {
    '& $container $header': {
      justifyContent: 'flex-end'
    }
  }
});